// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "CAD/CAM技术与应用",
      "tec": "王炳达",
      "week": "11-14周",
      "add": "教学楼A座215机房"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    0,
    0,
    0,
    0
  ],
  "3": [
    0,
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "智能制造技术",
      "tec": "鲍君善",
      "week": "1-8,11-14周",
      "add": "教学楼A座319机械"
    },
    {
      "sub": "CAD/CAM技术与应用",
      "tec": "王炳达",
      "week": "1-8,11-14周",
      "add": "教学楼A座215机房"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
